// src/views/bots/flow/components/EmptyCanvasHint.tsx
// Getting-started overlay shown on empty canvas when creating a new bot

import React from 'react';
import styles from './EmptyCanvasHint.module.css';

interface EmptyCanvasHintProps {
  onDismiss: () => void;
}

const EmptyCanvasHint: React.FC<EmptyCanvasHintProps> = ({ onDismiss }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.header}>
          <span className={styles.icon}>&#x1F4AC;</span>
          <h3 className={styles.title}>Build Your WhatsApp Bot</h3>
        </div>

        <div className={styles.steps}>
          <div className={styles.step}>
            <span className={styles.stepNumber}>1</span>
            <div className={styles.stepContent}>
              <strong>Add trigger keywords</strong>
              <p>Click the green Start node and type keywords like "price", "catalogue", or "hi"</p>
            </div>
          </div>

          <div className={styles.step}>
            <span className={styles.stepNumber}>2</span>
            <div className={styles.stepContent}>
              <strong>Drag question nodes</strong>
              <p>Pick a node type from the palette on the left — buttons, lists, text input, etc.</p>
            </div>
          </div>

          <div className={styles.step}>
            <span className={styles.stepNumber}>3</span>
            <div className={styles.stepContent}>
              <strong>Connect the flow</strong>
              <p>Drag from a circle on one node to another to build the conversation path</p>
            </div>
          </div>
        </div>

        <button className={styles.dismissBtn} onClick={onDismiss}>
          Got it, let's build!
        </button>
      </div>
    </div>
  );
};

export default EmptyCanvasHint;
